import React, { useState, useEffect } from "react";
import "./Contact.css";
import Header from "../../Components/Header/Header";
import ShopBanner from "../../Components/Banner/Banner";
import BottomNavigation from "../../Components/BottomMenu/BottomNavigation";
import { getWishist, deleteWishlist, getCartist, upsertcontactus, getcartwishlistcount } from "../../redux/services/productService";
import { useNavigate } from "react-router-dom";
import MapContainer from "../../Components/Map/MapContainer";
import { showSuccess } from "../../utils/alert";
import banner1 from "../../assets/images/banner1.png"
import HeaderDummy from "../../Components/Header/HeaderDummy";
import SearchHeader from "../../Components/Header/SearchHeader";
const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    helpType: "",
    email: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [cartCount, setCartCount] = useState(0);
  const [wishlist, setWishlist] = useState([]);
  const [isLowEndDevices, setIsLowEndDevices] = useState(window.innerWidth <= 950);
  const [cartwishlistCount, setCartwishlistCount] = useState({CartCount:0,WishlistCount:0,CartAmount:0});
  const navigate = useNavigate();

   
      
        useEffect(() => {
        const handleResize = () => setIsLowEndDevices(window.innerWidth <= 950);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);

     useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  // useEffect(() => {
  //   const fetchCart = async () => {
  //     try {
  //       const res = await getCartist();
  //       const parsed = JSON.parse(res.result);
  //       if (parsed?.Data) setCartCount(parsed.Data.length);
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   };
  //   fetchCart();
  // }, []);
  //  useEffect(() => {
  //      const fetchWishlist = async () => {
  //        try {
  //          const res = await getWishist();
  //          const parsedResult = JSON.parse(res.result);
  //          setWishlist(parsedResult.Data || []);
  //        } catch (error) {
  //          console.error("Error fetching wishlist:", error);
  //        }
  //      };
  
  //      fetchWishlist();
  //    }, []);
  useEffect(() => {
          const fetchCartWishlistCount = async () => {
            try {
              const res = await getcartwishlistcount({BE:1});
              if(res?.status =="Success"){
                const parsedResult = JSON.parse(res.result);
                
                setCartwishlistCount(parsedResult[0]);
              }
              else{
                setCartwishlistCount({});
              }
              
            } catch (error) {
              console.error("Error fetching wishlist:", error);
              setCartwishlistCount({});
            }
          };
      
          fetchCartWishlistCount();
        }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
  
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  
    // Remove error message for that field if it was previously set
    setErrors((prev) => {
      if (!prev[name]) return prev; // no change needed
      const updatedErrors = { ...prev };
      delete updatedErrors[name];
      return updatedErrors;
    });
  };
  

  const validateForm = () => {
    const newErrors = {};
  
    // First name validation
    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }
  
    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else {
      // Basic email format validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        newErrors.email = "Please enter a valid email address";
      }
    }
  
    // Help type validation
    if (!formData.helpType.trim()) {
      newErrors.helpType = "Please select a help topic";
    }
  
    // Message validation
    if (!formData.message.trim()) {
      newErrors.message = "Message cannot be empty";
    }
  
    return newErrors;
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    setErrors(formErrors);
    if (Object.keys(formErrors).length === 0) {
     
      try {
        
     
      const saveData = {
        id: 0,
        firstName: formData.firstName,
        lastName: formData?.lastName,
        help: formData?.helpType,
        email: formData?.email,
        message: formData?.message,
        be: 1
      }
      const response = await upsertcontactus(saveData);
      if (response?.status === "Success") {
        showSuccess("Message sent successfully!")
      setFormData({ firstName: "", lastName: "", helpType: "", email: "", message: "" });
      }
       } catch (error) {
        
      }
      
    }
  };

  return (
    <>
      {isLowEndDevices ? (
  <>

      <Header />
       <SearchHeader
        cartwishlistCount={cartwishlistCount}
        categories={[]}
        selectedCategory={null}
        cartTrigger={0}
        wishlistTrigger={0}
        otherScreens={true}
         />
     </>) : (
  <>
        <HeaderDummy/>
    <SearchHeader
        cartwishlistCount={cartwishlistCount}
        categories={[]}
        selectedCategory={null}
        cartTrigger={0}
        wishlistTrigger={0}
        otherScreens={true}
         />
    <Header />
  </>
)}
      <ShopBanner
        header=""
        badgeText="Contact Us"
        subheader=""
        backgroundImage={banner1}
        height="60px"
      />

      <div className="contact-container">
        {/* Breadcrumb */}
       
        <div className="contact-form-card">
          <h2>Contact Us</h2>
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-row">
              <div className="form-group">
                <label>First Name *</label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  placeholder="First"
                  className={errors.firstName ? "error" : ""}
                />
                {errors.firstName && <span className="error-message">{errors.firstName}</span>}
              </div>

              <div className="form-group">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  placeholder="Last"
                />
              </div>
            </div>

            <div className="form-group">
              <label>How can we help you? *</label>
              <select
                name="helpType"
                value={formData.helpType}
                onChange={handleInputChange}
                className={errors.helpType ? "error" : ""}
              >
                <option value="">Select an option</option>
                <option value={1}>Account Help</option>
                <option value={2}>Order Issue</option>
                <option value={3}>Product Info</option>
                <option value={4}>Other</option>
              </select>
              {errors.helpType && <span className="error-message">{errors.helpType}</span>}
            </div>

            <div className="form-group">
              <label>Email *</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Email"
                className={errors.email ? "error" : ""}
              />
              {errors.email && <span className="error-message">{errors.email}</span>}
            </div>

            <div className="form-group">
              <label>Comment or Message *</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Type your message here..."
                className={errors.message ? "error" : ""}
                rows="5"
              ></textarea>
              {errors.message && <span className="error-message">{errors.message}</span>}
            </div>

            <button type="submit" className="btn-submit">Submit</button>
          </form>
        </div>

        {/* <div className="chat-button">
          <span className="chat-text">Chat with us</span>
        </div> */}
      </div>

      <div style={{ padding: 15, marginBottom: '30px',height:'500px'}}>
        <MapContainer/>
      </div>

       <BottomNavigation
          cartCount={cartwishlistCount?.CartCount}
          wishlistCount={cartwishlistCount?.WishlistCount}
          onCartUpdate={() => {}}

        />
    </>
  );
};

export default Contact;
